// extracted by mini-css-extract-plugin
export default {"edmHeader":"src-pages-SalesChannelContentEditor-SalesChannelEditorProfilePage-Module-css__edmHeader--W1asQ"};